import { useEffect, useRef } from 'react';
import './score.css';
import abcjs from "abcjs";

function Score({speed,scale,fingers,tonality,notes,currentCycle,muted,isPlaying,isDS}) {
 const synth = useRef();
  useEffect(()=>{
    const keyScore = tonality;
    const notesCorrespondances = {};
    for(var key in notes){
      const n = notes[key];
      notesCorrespondances['s'+n.s+'n'+n.n]=n.text.replace('s','#').replace('f','b');
    }
    var fingering = '';
    const notesAbc = {s1:[],s2:[],s3:[],s4:[]};
    for(var key in fingers){
      if(fingers[key].class.match(/s1/)){
        notesAbc.s1.push({n:fingers[key].class.split(' ')[0]+fingers[key].class.split(' ')[1],f:fingers[key].class.split(' ')[2]});
      }
      if(fingers[key].class.match(/s2/)){
        notesAbc.s2.push({n:fingers[key].class.split(' ')[0]+fingers[key].class.split(' ')[1],f:fingers[key].class.split(' ')[2]});
      }
      if(fingers[key].class.match(/s3/)){
        notesAbc.s3.push({n:fingers[key].class.split(' ')[0]+fingers[key].class.split(' ')[1],f:fingers[key].class.split(' ')[2]});
      }
      if(fingers[key].class.match(/s4/)){
        notesAbc.s4.push({n:fingers[key].class.split(' ')[0]+fingers[key].class.split(' ')[1],f:fingers[key].class.split(' ')[2]});
      }
    }
    const notesAbcPrint = [];
    if(notesAbc.s4.length==2){
      notesAbcPrint.push({
        number:2,
        string:4,
        notes:[{n:notesCorrespondances[notesAbc.s4[0].n],f:notesAbc.s4[0].f},{n:notesCorrespondances[notesAbc.s4[1].n],f:notesAbc.s4[1].f}]
      }
      )

    }
    if(notesAbc.s3.length==2){
      notesAbcPrint.push({
        number:2,
        string:3,
        notes:[{n:notesCorrespondances[notesAbc.s3[0].n],f:notesAbc.s3[0].f},{n:notesCorrespondances[notesAbc.s3[1].n],f:notesAbc.s3[1].f}]
      }
      )
    }
    if(notesAbc.s2.length==2){
      notesAbcPrint.push({
        number:2,
        string:2,
        notes:[{n:notesCorrespondances[notesAbc.s2[0].n],f:notesAbc.s2[0].f},{n:notesCorrespondances[notesAbc.s2[1].n],f:notesAbc.s2[1].f}]
      }
      )
    }
    if(notesAbc.s1.length==2){
      notesAbcPrint.push({
        number:2,
        string:1,
        notes:[{n:notesCorrespondances[notesAbc.s1[0].n],f:notesAbc.s1[0].f},{n:notesCorrespondances[notesAbc.s1[1].n],f:notesAbc.s1[1].f}]
      }
      )
    }
    if(notesAbc.s4.length==1){
      notesAbcPrint.push({
        number:1,
        string:4,
        notes:[{n:notesCorrespondances[notesAbc.s4[0].n],f:notesAbc.s4[0].f}]
      }
      )
    }
    if(notesAbc.s3.length==1){
      
      notesAbcPrint.push({
        number:1,
        string:3,
        notes:[{n:notesCorrespondances[notesAbc.s3[0].n],f:notesAbc.s3[0].f}]
      }
      )
    }
    if(notesAbc.s2.length==1){
      notesAbcPrint.push({
        number:1,
        string:2,
        notes:[{n:notesCorrespondances[notesAbc.s2[0].n],f:notesAbc.s2[0].f}]
      }
      )
      
    }
    if(notesAbc.s1.length==1){
      notesAbcPrint.push({
        number:1,
        string:1,
        notes:[{n:notesCorrespondances[notesAbc.s1[0].n],f:notesAbc.s1[0].f}]
      }
      )
      
    }
        if(notesAbc.s4.length>=4){
      notesAbcPrint.push({
        number:4,
        string:4,
        notes:notesAbc.s4.map(n=>({n:notesCorrespondances[n.n],f:n.f}))
      }
      )
    }
    if(notesAbc.s3.length>=4){
      
      notesAbcPrint.push({
        number:4,
        string:3,
        notes:notesAbc.s3.map(n=>({n:notesCorrespondances[n.n],f:n.f}))
      }
      )
    }
    if(notesAbc.s2.length>=4){
      notesAbcPrint.push({
        number:4,
        string:2,
        notes:notesAbc.s2.map(n=>({n:notesCorrespondances[n.n],f:n.f}))
      }
      )
      
    }
    if(notesAbc.s1.length>=4){
      notesAbcPrint.push({
        number:4,
        string:1,
        notes:notesAbc.s1.map(n=>({n:notesCorrespondances[n.n],f:n.f}))
      }
      )
      
    }

    for(var key in notesAbcPrint){
      if(notesAbcPrint[key].string == 1){
        for(var n in notesAbcPrint[key].notes){
          if(notesAbcPrint[key].notes[n].n.match(/C/) || notesAbcPrint[key].notes[n].n.match(/D/) || notesAbcPrint[key].notes[n].n.match(/E/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          if(currentCycle >= 2){
            if(notesAbcPrint[key].notes[n].n.match(/F/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 4){
            if(notesAbcPrint[key].notes[n].n.match(/G/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 6){
            if(notesAbcPrint[key].notes[n].n.match(/A/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 7){
            if(notesAbcPrint[key].notes[n].n.match(/B/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 9){
            if(notesAbcPrint[key].notes[n].n.match(/C/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 11){
            if(notesAbcPrint[key].notes[n].n.match(/D/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
        }
      }
      if(notesAbcPrint[key].string == 3){
        for(var n in notesAbcPrint[key].notes){
          if(notesAbcPrint[key].notes[n].n.match(/C/) || notesAbcPrint[key].notes[n].n.match(/D/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          if(currentCycle >= 2){
            if(notesAbcPrint[key].notes[n].n.match(/E/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 4){
            if(notesAbcPrint[key].notes[n].n.match(/F/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 5){
            if(notesAbcPrint[key].notes[n].n.match(/G/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 8){
            if(notesAbcPrint[key].notes[n].n.match(/A/)||notesAbcPrint[key].notes[n].n.match(/B/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 10){
            if(notesAbcPrint[key].notes[n].n.match(/C/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
        }
      }

      if(notesAbcPrint[key].string == 4){
        for(var n in notesAbcPrint[key].notes){
          
          if(currentCycle <= 2){

            if(notesAbcPrint[key].notes[n].n?.match(/A/) || notesAbcPrint[key].notes[n].n?.match(/B/)){
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+',';
            }
          }
          if(currentCycle >= 6){

            if(notesAbcPrint[key].notes[n].n.match(/C/)){
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
            }
          }
          if(currentCycle >= 7){

            if(notesAbcPrint[key].notes[n].n.match(/D/)){
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
            }
          }
          if(currentCycle >= 9){

            if(notesAbcPrint[key].notes[n].n.match(/E/)){
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
            }
          }
          if(currentCycle >= 10){

            if(notesAbcPrint[key].notes[n].n.match(/F/)){
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
            }
          }

        }
      }
      if(notesAbcPrint[key].string == 2){
        for(var n in notesAbcPrint[key].notes){
          if(notesAbcPrint[key].notes[n].n.match(/C/) || notesAbcPrint[key].notes[n].n.match(/D/) || notesAbcPrint[key].notes[n].n.match(/E/) || notesAbcPrint[key].notes[n].n.match(/F/) || notesAbcPrint[key].notes[n].n.match(/G/) || notesAbcPrint[key].notes[n].n.match(/A/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          if(currentCycle >= 2){
            if(notesAbcPrint[key].notes[n].n.match(/B/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 4){
            if(notesAbcPrint[key].notes[n].n.match(/C/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 6){
            if(notesAbcPrint[key].notes[n].n.match(/D/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 7){
            if( notesAbcPrint[key].notes[n].n.match(/E/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 8){
            if( notesAbcPrint[key].notes[n].n.match(/F/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
          if(currentCycle >= 10){
            if( notesAbcPrint[key].notes[n].n.match(/G/))
            notesAbcPrint[key].notes[n].n = notesAbcPrint[key].notes[n].n+'\'';
          }
        }
      }
    }
    var lastStr = [];
    if(isDS){
        if(notesAbcPrint.length == 2){

        lastStr[1] = notesAbcPrint[0]?.notes?.map(n=>n.n+'/2').join('');
        fingering = notesAbcPrint[0]?.notes?.map(n=>n.f[1]).join(' ')+' ';
        lastStr[0] = notesAbcPrint[1]?.notes?.map(n=>'!'+n.f+'!'+n.n+'/2').join('');
        }
        else if(notesAbcPrint.length == 3){
        lastStr[1] = notesAbcPrint[0]?.notes?.map(n=>n.n+'/2').join('')+' ';
        lastStr[1] += notesAbcPrint[1]?.notes?.map((n,i)=>i>=4?n.n+'/2':'').join('');
        fingering = notesAbcPrint[0]?.notes?.map(n=>n.f[1]).join(' ')+' ';
        fingering += notesAbcPrint[1]?.notes?.map((n,i)=>i>=4?n.f[1]:'').join(' ');
        lastStr[0] = notesAbcPrint[1]?.notes?.map((n,i)=>i<4?'!'+n.f+'!'+n.n+'/2':'').join('')+' ';
        lastStr[0] += notesAbcPrint[2]?.notes?.map(n=>'!'+n.f+'!'+n.n+'/2').join('');
        }
    }
    else if(scale){

    for(var key in notesAbcPrint){
      lastStr[notesAbcPrint[key].string] = notesAbcPrint[key].notes.map(n=>'!'+n.f+'!'+n.n+'/2').join('');
    }
    lastStr.reverse();
    }else{
    for(var key in notesAbcPrint){
      if(notesAbcPrint[key].number == 2){
        lastStr[notesAbcPrint[key].string] = '!'+notesAbcPrint[key].notes[0].f+'!'+notesAbcPrint[key].notes[0].n+'/2'+'!'+notesAbcPrint[key].notes[1].f+'!'+notesAbcPrint[key].notes[1].n+'/2'+notesAbcPrint[key].notes[0].n+'/2'+notesAbcPrint[key].notes[1].n+'/2'+' '+notesAbcPrint[key].notes[0].n+'/2'+notesAbcPrint[key].notes[1].n+'/2'+notesAbcPrint[key].notes[0].n+'/2'+notesAbcPrint[key].notes[1].n+'/2';
      }else{
        fingering = notesAbcPrint[key].notes[0].f[1];
        lastStr[notesAbcPrint[key].string] = notesAbcPrint[key].notes[0].n+'4';
      }
    }
  }
  if(!lastStr.length)
    return;
const abcString = scale&&!isDS?lastStr.filter(n=>n).join('').replace(/(?![A-Z&\/0-9 !,'])./g, '')+' '+lastStr.filter(n=>n).join('').replace(/(?![A-Z&\/0-9 ",'!])./g, '').split('/2').reverse().filter(n=>n).join('/2')+'/2':
scale?
lastStr.filter(n=>n)[0].replace(/(?![A-Z&\/0-9 ",'!])./g, '')+' '+lastStr.filter(n=>n)[0].replace(/(?![A-Z&\/0-9 ",'!])./g, '').replace(/\!(.*?)\!/g,'').split('/2').reverse().filter(n=>n).join('/2').replace(' ','')+'/2' + ' & '+lastStr.filter(n=>n)[1].replace(/(?![A-Z&\/0-9 ",'!])./g, '')+' '+lastStr.filter(n=>n)[1].replace(/(?![A-Z&\/0-9 ",'!])./g, '').split('/2').reverse().filter(n=>n).join('/2').replace(' ','')+'/2' + ''
:lastStr.filter(n=>n).join(' & ').replace(/(?![A-Z&\/0-9 ,'!])./g, '');

var visualObj = abcjs.renderAbc("scoreAbc",`X:1\nK:${keyScore.toString().replace('s','#').replace('f','b')}\n  |: ${abcString} :| ${fingering?'\nw:'+fingering+'':''}`,{staffwidth:400, paddingbottom:0,paddingleft:0,paddingright:0,selectTypes:false,paddingtop:0,responsive: "resize" })
if(!muted && isPlaying){
var myContext = new AudioContext();
synth.current?.stop();
if(!synth.current)
  synth.current = new abcjs.synth.CreateSynth();
synth.current.init({
    audioContext: myContext,
    visualObj: visualObj[0],
    millisecondsPerMeasure: speed==1?speed*2*950:speed*950,
    options: {
      program:4
    }
}).then(function (results) {
  synth.current.prime().then((response) => {
		
        synth.current.start();
    });
    // Ready to play. The results are details about what was loaded.
}).catch(function (reason) {
    //console.log(reason)
});
}
  },[tonality,fingers,notes,speed,isPlaying])
  useEffect(()=>{
    if(!isPlaying || muted){
      synth.current?.pause();
    }
    if(isPlaying && !muted){
      synth.current?.resume();
    }
  },[isPlaying,muted])
  return (
   <div id="scoreAbc"></div>

  );
}

export default Score;